/**
 * Plan delta service — snapshot diffs and cycle-over-cycle reallocation (WS-E).
 *
 * PRD: docs/9-exploration/PRD-scorecard-to-strongest.md.
 * Views: supabase/migrations/683_plan_reallocation_delta.sql. Read-only —
 * these are read models over the existing record; nothing here writes.
 *
 * L1: an empty result is the honest answer when a cycle lacks two authorized
 * snapshots or a carried-forward predecessor — render "no basis", never a
 * synthetic delta.
 */

import { getTypedSupabaseClient } from './typedSupabaseClient';
import type { Database } from '../types/database.generated';

export type PlanSnapshotDeltaRow =
  Database['public']['Views']['plan_snapshot_deltas']['Row'];
export type PlanCycleReallocationRow =
  Database['public']['Views']['plan_cycle_reallocation_delta']['Row'];

export async function listSnapshotDeltasForCycle(
  planCycleId: string
): Promise<{ rows: PlanSnapshotDeltaRow[]; error?: string }> {
  const db = getTypedSupabaseClient();
  const { data, error } = await db
    .from('plan_snapshot_deltas')
    .select('*')
    .eq('plan_cycle_id', planCycleId);
  if (error) return { rows: [], error: error.message };
  return { rows: data ?? [] };
}

export async function listReallocationDeltaForCycle(
  planCycleId: string
): Promise<{ rows: PlanCycleReallocationRow[]; error?: string }> {
  const db = getTypedSupabaseClient();
  const { data, error } = await db
    .from('plan_cycle_reallocation_delta')
    .select('*')
    .eq('plan_cycle_id', planCycleId);
  if (error) return { rows: [], error: error.message };
  return { rows: data ?? [] };
}
